import React from 'react';
import styled from 'styled-components';

const StepContainer = styled.div`max-width: 700px; margin: 0 auto;`;
const StepTitle = styled.h2`font-size: 1.5rem; font-weight: 600; color: #1F2937; margin-bottom: 0.5rem;`;
const StepSubtitle = styled.p`color: #6B7280; margin-bottom: 2rem; font-size: 0.95rem;`;
const InfoCard = styled.div`
  background: #F0F4FF; border: 2px solid #C7D2FE; border-radius: 12px; padding: 1.25rem 1.5rem;
  p { margin: 0; font-size: 0.95rem; color: #374151; line-height: 1.5; }
  strong { color: #1F2937; }
`;

const SharedStep_Preferences = ({ data, updateData, lang = 'fr', populationType }) => {
  const isPopB = populationType === 'pop_b';

  return (
    <StepContainer>
      <StepTitle>{lang === 'fr' ? 'Informations complémentaires' : 'Additional information'}</StepTitle>

      <InfoCard>
        {isPopB ? (
          <p>
            {lang === 'fr'
              ? <>Après validation de votre profil, vous pourrez consulter les demandes des entreprises et effectuer vos <strong>demandes de rendez-vous (candidatures)</strong> directement sur la plateforme. Vous aurez jusqu'au <strong>vendredi 4 septembre, minuit</strong>, pour compléter et amender vos demandes de rendez-vous.</>
              : <>After your profile is validated, you will be able to browse company requests and submit your <strong>meeting requests (candidatures)</strong> directly on the platform. You have until <strong>Friday, September 4, midnight</strong>, to complete and amend your meeting requests.</>}
          </p>
        ) : (
          <p>
            {lang === 'fr'
              ? <>Rappel : le Speed Dating Design Objet se tiendra <strong>en présentiel</strong> le <strong>mardi 29 septembre 2026</strong>, à <strong>Le FRENCH DESIGN Galerie</strong>. Chaque rendez-vous dure <strong>15 minutes</strong>.</>
              : <>Reminder: the Speed Dating Design Objet will take place <strong>in person</strong> on <strong>Tuesday, September 29, 2026</strong>, at <strong>Le FRENCH DESIGN Galerie</strong>. Each meeting lasts <strong>15 minutes</strong>.</>}
          </p>
        )}
      </InfoCard>
    </StepContainer>
  );
};

export default SharedStep_Preferences;
